// src/services/notificationService.ts
import { Notification } from "@/composables/useNotification";

/**
 * Serviço para gerenciar notificações de forma independente dos composables Vue
 * Permite que serviços não-Vue possam disparar notificações
 */

// Interface para manipuladores de notificação
type NotificationHandler = (
	message: string,
	options?: Partial<Omit<Notification, "id" | "message" | "type">>
) => string;

// Interface para manipuladores por tipo
interface NotificationHandlers {
	success: NotificationHandler;
	error: NotificationHandler;
	warning: NotificationHandler;
	info: NotificationHandler;
}

// Armazenam os manipuladores de notificação
let handlers: Partial<NotificationHandlers> = {};

// Função para registrar manipuladores
export const registerNotificationHandlers = (
	newHandlers: Partial<NotificationHandlers>
) => {
	handlers = { ...handlers, ...newHandlers };
};

// Funções para emitir notificações
export const showSuccess = (
	message: string,
	options?: Partial<Omit<Notification, "id" | "message" | "type">>
): string | undefined => {
	if (handlers.success) {
		return handlers.success(message, options);
	} else {
		return undefined;
	}
};

export const showError = (
	message: string,
	options?: Partial<Omit<Notification, "id" | "message" | "type">>
): string | undefined => {
	if (handlers.error) {
		return handlers.error(message, options);
	} else {
		console.error("[Notification] Error:", message);
		return undefined;
	}
};

export const showWarning = (
	message: string,
	options?: Partial<Omit<Notification, "id" | "message" | "type">>
): string | undefined => {
	if (handlers.warning) {
		return handlers.warning(message, options);
	} else {
		console.warn("[Notification] Warning:", message);
		return undefined;
	}
};

export const showInfo = (
	message: string,
	options?: Partial<Omit<Notification, "id" | "message" | "type">>
): string | undefined => {
	if (handlers.info) {
		return handlers.info(message, options);
	} else {
		console.warn("[Notification] Info handler not registered:", message);
		return undefined;
	}
};

/**
 * Este serviço não depende de composables Vue e pode ser usado em qualquer lugar
 * Inicialize o serviço no App.vue ao montar o aplicativo
 */
